// import anime from "animejs/lib/anime.es.js";
import Highway from "@dogstudio/highway";

import SliderMedia from "../components/sliderMedia";

var presentObject = {};

class Present extends Highway.Renderer {
  onEnter() {
    presentObject.sliderMedia = new SliderMedia().init();
  }
  onEnterCompleted() {}

  onLeave() {}

  onLeaveCompleted() {
    presentObject = {};
  }
}

export default Present;



// WEBPACK FOOTER //
// ./scripts/routes/present.js